import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import BackendMobile from '../../../../Layouts/BackendMobile';
import { Button, Dropdown } from '../../../../UI/Common';

function MobileConfigurationPresetsPage({ t, mobileConfig, ...props }) {
  const _mobileConfigId = localStorage.getItem('mobileConfigId') || 'default';
  const [mobileConfigId, setMobileConfigId] = React.useState(_mobileConfigId);

  return (
    <BackendMobile>
      <div className="content-inner">
        <Dropdown
          required
          noLabel
          label="Preset"
          data={[
            { name: 'Default', id: 'default' },
            ...mobileConfig.mobileConfigs,
          ]}
          value={mobileConfigId}
          onChange={({ value }) => setMobileConfigId(value)}
          valueKey="id"
          nameKey="name"
          subtitleKey="id"
        />
        <Button onClick={() => props.onSave(mobileConfigId)}>
          <i className="md-icon">done</i>
          {t('Apply')}
        </Button>
      </div>
    </BackendMobile>
  );
}

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
  };
}

export default withTranslation('app')(
  connect(mapStateToProps, null)(MobileConfigurationPresetsPage),
);
